/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import { isAuthorized } from '../services/auth.service';

export function AuthorizedUser(): MethodDecorator {
    return function (target: Function, key: string, descriptor: any): any {
        const originalMethod = descriptor.value;

        descriptor.value = function (...args: any[]) {
            if (!isAuthorized()) {
                throw new Error(`Unauthorized users unable to perform this operation!`);
            }

            return originalMethod.apply(this, args);
        };

        return descriptor;
    } as MethodDecorator;
}
